import * as React from 'react';
import Cards from '@cloudscape-design/components/cards';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { DocumentContext } from '../../context/documentContext';
import { useContext } from 'react';
import Link from '@cloudscape-design/components/link';
import { kbSentenceItem } from '../../models/interfaces';
import {
  Button,
  CopyToClipboard,
  TextContent
} from '@cloudscape-design/components';

interface Props {
  kbresults: kbSentenceItem[];
}

export const FreeformKnowledgebase = (props: Props) => {
  const { kbresults } = props;

  const { setFreeformeSelectedItems, freeformSelectedItems } =
    useContext(DocumentContext);

  const copyToClipboard = async (value: string) => {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/plain': new Blob([value], { type: 'text/plain' })
        })
      ]);
      console.log('Formatted text copied to clipboard.');
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };
  return (
    <SpaceBetween direction="vertical" size="l">
      <>
        <Cards
          onSelectionChange={({ detail }) =>
            setFreeformeSelectedItems(detail?.selectedItems ?? [])
          }
          selectedItems={freeformSelectedItems}
          cardDefinition={{
            sections: [
              {
                id: 'text',
                header: 'Text',
                content: (item) => item.text
              },

              {
                id: 'Context',
                header: 'Context',
                content: (item) => item.Context
              },
              {
                id: 'parameters',
                header: 'Parameters',
                content: (item) => item.All_Parameters.join(' ')
              },
              {
                id: 'kbType',
                header: 'Type',
                content: (item) => item.knowledge_base_type
              },
              {
                id: 'Similarity',
                header: 'Similarity',
                content: (item) =>
                  !isNaN(item.similarity * 100)
                    ? `${(item.similarity * 100).toFixed(2)} %`
                    : ''
              },
              {
                id: 'link',
                header: 'Link',
                content: (item) => <Link href="">{item.docName}</Link>
              }
            ]
          }}
          cardsPerRow={[{ cards: 1 }]}
          items={kbresults}
          loadingText="Loading resources"
          selectionType="multi"
          trackBy="_id"
          visibleSections={[
            'text',
            'link',
            'parameters',
            'kbType',
            'Similarity',
            'Context'
          ]}
          empty={
            <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
              <SpaceBetween size="m">
                <br />
                <b>No results found</b>
              </SpaceBetween>
            </Box>
          }
        />
      </>
    </SpaceBetween>
  );
};
